module.exports = __webpack_public_path__ + "media/img/home/clients-map/og-41f4ecf6d72c3f84ee40d57c1f1d127a.svg";